import React, { Component } from 'react';
import { Link } from 'react-router-dom';
import axios from 'axios'
import { Table, Icon, Button } from 'semantic-ui-react'
import { firebaseAuth, pythonApiIp, toCurrency } from '../../../../config/constants'
import { checkAdminEmail } from '../algoliaDashboard/AlgoliaMiscUtils';
import * as UiConsts from '../../../../config/UiConstants';
import ViewLargeProjectDocChangeProjectType from './ViewLargeProjectDocChangeProjectType'
import ViewLargeProjectDocSendMissingSlack from './ViewLargeProjectDocSendMissingSlack'


class ViewLargeProjectDocuments extends Component {
    constructor(props) {
        super(props);
        this.state = {
            loading: false,
            docView: []
        }
    }

    componentDidMount() {
        console.log("addx2 ++++++++++ searchNow componentDidMount");
        console.log("filtx: filter:" + this.props.filter)

        // this.getProjectList();


        this.removeListener = firebaseAuth().onAuthStateChanged((user) => {
            console.log("addx24 +++++++++:firebaseAuth().onAuthStateChanged");

            if (user) {
                console.log("addx241 user is:" + user.email);
                // let isAnonymous = user.isAnonymous;
                // let uid = user.uid;

                if (user.email) {
                    console.log("addx290 user.email  is:" + user.email);
                    this.setState({
                        user: user
                    })

                    //CHECK ALGOLIA FOR USER
                    checkAdminEmail(user.email, this.setAdminResult);
                    this.getDocumentView();
                    //  this.getApiDetails();
                    //this.getProjectList();
                    // getProjectList(this.loadProjectList,this.props.filter, this.props.salesPersonId)
                }

            } else {
                console.log("rlx121 user NOT found");
                this.setState({
                    authed: false,
                    // loading: false,
                    user: user,
                    uid: user.uid
                })

            }
        })

    }

    
    setAdminResult = (returnObject) => {
        console.log("++++++ addx294 setAdminResult");
        console.log("addx2941 returnObject:" + JSON.stringify(returnObject, null, 3));
        this.setState({
            algoliaUser: returnObject.algoliaUser,
            //isAdmin: returnObject.isAdmin,
        })
    }


    getDocumentView = () => {
       // console.log("gdocx1 ++++++++:getDocumentView");

        this.setState({ loading: true })

        axios.post(pythonApiIp + 'getDocumentView', {
            apiKey: "asdfsdf&343k",
            projectId: this.props.projectId
        })
            .then((response) => {
                this.setState({ loading: false })

              //  console.log("gdocx1 results:" + JSON.stringify(response.data, null, 3));

                if (response.data.result) {
                  //  console.log("gdocx1true.. got docs");
                    this.setState({ docView: response.data.docView })

                } else {
                    console.log("FAILED");
                    //  alert(response.data.message);
                }
            })
            .catch((error) => {
                this.setState({ loading: false })
                console.log("extt1:" + error);

            });
    }

    setProjectType = (projectType) => {
        console.log("spjx1 ++++++++:setProjectType");
        console.log("spjx12 projectType:"+projectType)

        this.setState({ loading: true })

        axios.post(pythonApiIp + 'setProjectType', {
            apiKey: "asdfsdf&343k"
        })
            .then((response) => {
                this.setState({ loading: false })

               // console.log("gdocx1 results:" + JSON.stringify(response.data, null, 3));

                if (response.data.result) {
                  //  console.log("gdocx1true.. got docs");
                    this.setState({ docView: response.data.docView })

                } else {
                    console.log("FAILED");
                    //  alert(response.data.message);
                }
            })
            .catch((error) => {
                this.setState({ loading: false })
                console.log("extt1:" + error);

            });
    }

    render() {


        const ShowCheckMarks = (props) => (

            props.answer == 'yes'
                ?<div>
                    {props.item}
                    <Icon color='green' name='checkmark' size='large' />
                </div>
                : <div>
                    {props.item}
                    <Icon color='red' name='close' size='large' />
                </div>
        )

        const rows = this.state.docView.length > 0
            ? this.state.docView.map((item) =>
                <Table.Row>
                    <Table.Cell> {item.idlargeprojects} </Table.Cell>
                    <Table.Cell> {item.project} </Table.Cell>
                    <Table.Cell> {item.projecttype} </Table.Cell>
                    <Table.Cell> {toCurrency(item.totalpayment)} </Table.Cell>
                    
                    <Table.Cell> <ViewLargeProjectDocChangeProjectType user={this.state.user}  projectId={item.idlargeprojects} reload={this.getDocumentView}/> </Table.Cell>
                    {/* <Table.Cell> {item.datecreated} </Table.Cell> */}
                    {/* <Table.Cell> {item.po} </Table.Cell> */}
                    <Table.Cell>
                        <ViewLargeProjectDocSendMissingSlack item={'po'} answer={item.po} projectId={item.idlargeprojects} user={this.state.user}/> 
                    </Table.Cell>

                    {/* <Table.Cell> <ShowCheckMarks item={'invoice'} answer={item.invoice}/> </Table.Cell> */}
                    <Table.Cell>
                        <ViewLargeProjectDocSendMissingSlack item={'invoice'} answer={item.invoice} projectId={item.idlargeprojects} user={this.state.user}/> 
                    </Table.Cell>

                    <Table.Cell>
                        <ViewLargeProjectDocSendMissingSlack item={'delivery_note'} answer={item.delivery_note} projectId={item.idlargeprojects} user={this.state.user}/> 
                    </Table.Cell>

                    <Table.Cell>
                        <ViewLargeProjectDocSendMissingSlack item={'receipt'} answer={item.receipt} projectId={item.idlargeprojects} user={this.state.user}/> 
                    </Table.Cell>

                    <Table.Cell>
                        <ViewLargeProjectDocSendMissingSlack item={'delivered'} answer={item.delivered} projectId={item.idlargeprojects} user={this.state.user}/> 
                    </Table.Cell>

                    <Table.Cell> {item.paymentstatus}</Table.Cell>
                    {/* <Table.Cell> {item.numorders}</Table.Cell> */}
                    <Table.Cell> <ShowCheckMarks item={'hasorder'} answer={item.hasorder}/> </Table.Cell>
                    <Table.Cell> <ShowCheckMarks item={'archived'} answer={item.archived}/> </Table.Cell>
                    <Table.Cell> {item.salesperson}</Table.Cell>
                    <Table.Cell> <Link to={'/dashboard/viewLargeProject/' + item.idlargeprojects } target="_blank">VIEW</Link></Table.Cell>
                    {/* <CostApprovedRow item={item} /> */}
                    {/* <SalesPersonApprovedRow item={item} /> */}
                    {/* <Table.Cell> <SalesPersonApprovedRow item={item} /></Table.Cell> */}
                </Table.Row>)
            : ''

        return (
            this.state.loading ? <UiConsts.LoadingComponent /> : <div>
                <h2>PROJECTS - {this.state.docView.length}</h2>
                <Table celled>
                    <Table.Header>
                        <Table.Row>
                            <Table.HeaderCell>Id</Table.HeaderCell>
                            <Table.HeaderCell>Project</Table.HeaderCell>
                            <Table.HeaderCell>Project Type</Table.HeaderCell>
                            <Table.HeaderCell>Total</Table.HeaderCell>
                            <Table.HeaderCell>Set Type</Table.HeaderCell>
                            <Table.HeaderCell>po</Table.HeaderCell>
                            <Table.HeaderCell>invoice</Table.HeaderCell>
                            <Table.HeaderCell>Del Note</Table.HeaderCell>
                            <Table.HeaderCell>receipt</Table.HeaderCell>
                            <Table.HeaderCell>delivered</Table.HeaderCell>
                            <Table.HeaderCell>paymentstatus</Table.HeaderCell>
                            {/* <Table.HeaderCell>numorders</Table.HeaderCell> */}
                            <Table.HeaderCell>hasorder</Table.HeaderCell>
                            <Table.HeaderCell>archived</Table.HeaderCell>
                            <Table.HeaderCell>SALES PERSON</Table.HeaderCell>
                            <Table.HeaderCell>EDIT</Table.HeaderCell>


                        </Table.Row>
                    </Table.Header>

                    <Table.Body>
                        {rows}
                    </Table.Body>

                </Table>
            </div>
        );
    }
}

export default ViewLargeProjectDocuments;


// WEBPACK FOOTER //
// ./src/components/dashBoard/newDashboard/LargeProjects/ViewLargeProjectDocuments.js